export const RECIPIENT_STATES = {
    PENDING: 'pending',
    FILTERED: 'filtered',
    READY_TO_SEND: 'ready_to_send',
    SENT: 'sent',
    FAILED: 'failed',
    CANCELLED: 'cancelled',
};

export const MESSAGE_STATES = {
    EDIT: 'edit',
    PREPARE: 'prepare',
    REVIEW: 'review',
    SEND: 'send',
    PAUSED: 'paused',
    FINISHED: 'finished',
    CANCELLED: 'cancelled',
};

export const ACTIVE_RECIPIENT_STATES_BY_MESSAGE_STATE = {
    [MESSAGE_STATES.PREPARE]: [RECIPIENT_STATES.PENDING, RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.READY_TO_SEND],
    [MESSAGE_STATES.REVIEW]: [RECIPIENT_STATES.PENDING, RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.READY_TO_SEND],
    [MESSAGE_STATES.SEND]: [RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.FAILED, RECIPIENT_STATES.READY_TO_SEND, RECIPIENT_STATES.CANCELLED, RECIPIENT_STATES.SENT],
    [MESSAGE_STATES.PAUSED]: [RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.FAILED, RECIPIENT_STATES.READY_TO_SEND, RECIPIENT_STATES.CANCELLED, RECIPIENT_STATES.SENT],
    [MESSAGE_STATES.FINISHED]: [RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.FAILED, RECIPIENT_STATES.CANCELLED, RECIPIENT_STATES.SENT],
    [MESSAGE_STATES.CANCELLED]: [RECIPIENT_STATES.FILTERED, RECIPIENT_STATES.FAILED, RECIPIENT_STATES.CANCELLED, RECIPIENT_STATES.SENT],
};

export const INACTIVE_REASONS_BY_RECIPIENT_STATE = {
    [RECIPIENT_STATES.PENDING]: 'This status is only relevant before sending begins',
    [RECIPIENT_STATES.FILTERED]: 'This status is only relevant before sending begins',
    [RECIPIENT_STATES.READY_TO_SEND]: 'This status is only relevant before sending finishes',
    [RECIPIENT_STATES.FAILED]: "This status is only relevant once you've sent your message",
    [RECIPIENT_STATES.CANCELLED]: "This status is only relevant once you've sent your message",
    [RECIPIENT_STATES.SENT]: "This status is only relevant once you've sent your message",
};

export function isRecipientStateActive(message_state, recipient_state) {
    const active_states = ACTIVE_RECIPIENT_STATES_BY_MESSAGE_STATE[message_state] || [];
    return active_states.includes(recipient_state);
}

export function getInactiveReason(message_state, recipient_state) {
    if (isRecipientStateActive(message_state, recipient_state)) {
        return null;
    }
    return INACTIVE_REASONS_BY_RECIPIENT_STATE[recipient_state] || null;
}

export function getActiveRecipientStates(message_state) {
    return ACTIVE_RECIPIENT_STATES_BY_MESSAGE_STATE[message_state] || [];
}
